export enum Featureflag {
  CADDIE_SPLIT_TEST = 'caddie-split--test',
  ENGAGE = 'engage',
  DYNAMIC_HINTS = 'dynamic-hints',
  AI_FILTERS = 'ai-filters',
  COLLECTIONS = 'collections',
  // Engagement pack
  EXIT_INTENT = 'exit-intent',
  DELAYED_LOAD = 'delayed-load',
  HIDE_ON_SCROLL = 'hide-on-scroll',
  CONVERSION_TRACKING = 'conversion-tracking',
}

export const FeatureFlagVariant = {
  [Featureflag.CADDIE_SPLIT_TEST]: {
    CADDIE_VISIBLE: 'caddie-visible',
    CONTROL: 'control',
  },
};
